"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.zonedTimeToUtc = exports.utcToZonedTime = void 0;
var _dateFnsTz = require("date-fns-tz");
var _dateFns = require("date-fns");
const utcToZonedTime = (date, timeZone, options) => {
  const parsedDate = (0, _dateFnsTz.utcToZonedTime)(date, timeZone, options);
  if ((0, _dateFns.isValid)(parsedDate)) {
    return parsedDate;
  }
  console.error("Could not convert to zoned time from utc");
  return new Date(0, 0);
};
exports.utcToZonedTime = utcToZonedTime;
const zonedTimeToUtc = (date, timeZone, options) => {
  const parsedDate = (0, _dateFnsTz.zonedTimeToUtc)(date, timeZone, options);
  if ((0, _dateFns.isValid)(parsedDate)) {
    return parsedDate;
  }
  console.error("Could not convert to utc from zoned time");
  return new Date(0, 0);
};
exports.zonedTimeToUtc = zonedTimeToUtc;